import { render } from "./NonComplianceView.vue?vue&type=template&id=25c08dae&scoped=true"
import script from "./NonComplianceView.vue?vue&type=script&lang=js"
export * from "./NonComplianceView.vue?vue&type=script&lang=js"

import "./NonComplianceView.vue?vue&type=style&index=0&id=25c08dae&scoped=true&lang=css"

import exportComponent from "/var/www/html/auditoria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c08dae"]])

export default __exports__